import { message } from 'antd';
import { safeGetMessage } from '@xbcb/ui-utils';
import { isEudrDetectionEnabled } from 'libs/eudr/isEudrDetectionEnabled';
import {
  countIncompleteEudrEntries,
  eudrEntriesOfDeclaration,
  incompleteSkippedMessage,
  isEudrEntryVerifiable,
  submitEudrDdsVerification,
} from 'libs/eudr/submitEudrDdsVerification';
import { eudrEntryHasInput } from 'libs/formCore/schemas';
import { hasUnsavedGoodsChanges } from 'libs/formCore/transforms/hasUnsavedGoodsChanges';
import { AppRecordKebabMenuItem } from '../../../../types';

const show: AppRecordKebabMenuItem['show'] = ({ existingRecord }) =>
  isEudrDetectionEnabled() &&
  eudrEntriesOfDeclaration(existingRecord?.goodsShipment).some(
    eudrEntryHasInput,
  );

let submitting = false;

const action: AppRecordKebabMenuItem['action'] = async ({
  record,
  appRecordBundle,
}) => {
  if (submitting) return;
  if (hasUnsavedGoodsChanges()) {
    void message.warning(
      safeGetMessage(appRecordBundle, 'eudr_verify_save_changes'),
    );
    return;
  }
  const entries = eudrEntriesOfDeclaration(record?.goodsShipment);
  const submittableCount = entries.filter(isEudrEntryVerifiable).length;
  const incompleteCount = countIncompleteEudrEntries(entries);
  if (!submittableCount) {
    void (incompleteCount
      ? message.warning(
          incompleteSkippedMessage(incompleteCount, appRecordBundle),
        )
      : message.info(
          safeGetMessage(appRecordBundle, 'eudr_nothing_to_verify'),
        ));
    return;
  }
  submitting = true;
  try {
    await submitEudrDdsVerification({
      customsDeclarationId: record.id,
      bundle: appRecordBundle,
      submittableCount,
      incompleteCount,
      refetchQueries: ['CustomsDeclaration'],
    });
  } finally {
    submitting = false;
  }
};

export const verifyEudrDds: AppRecordKebabMenuItem = {
  show,
  action,
  key: 'verifyEudrDds',
  text: ({ appRecordBundle }) =>
    safeGetMessage(appRecordBundle, 'verify_eudr_dds'),
};
